"use client";

import { detailReportConfig } from "@/config/detail";
import { sharedRouteConfig } from "@/config/shared";
import { createClient } from "@/utils/supabase/client";
import { Flag, Loader2 as SpinnerIcon } from "lucide-react";
import { useRouter } from "next/navigation";
import React, { FC } from "react";
import toast from "react-hot-toast";

interface DetailPostReportProps {
  url?: string;
}

const DetailPostReportButton: FC<DetailPostReportProps> = ({
  url = window.location.href,
}) => {
  const [isHovering, setIsHovered] = React.useState(false);
  const onMouseEnter = () => setIsHovered(true);
  const onMouseLeave = () => setIsHovered(false);
  const router = useRouter();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  return (
    <button
      type="button"
      disabled={isLoading}
      onClick={() => router.push(sharedRouteConfig.contact)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      title="Add bookmark"
      className="group relative mx-auto inline-flex w-full items-center justify-center rounded-md border border-black/5 bg-white py-2 hover:bg-gray-50 hover:shadow-sm"
    >
      {isLoading ? (
        <SpinnerIcon className="-ml-0.5 h-5 w-5 animate-spin" />
      ) : isHovering ? (
        <Flag className="-ml-0.5 h-5 w-5 text-gray-900" fill="#000" />
      ) : (
        <Flag className="-ml-0.5 h-5 w-5 text-gray-400" />
      )}
      <span className="ml-2 hidden text-sm text-gray-400 group-hover:text-gray-900 md:flex">
        {detailReportConfig.title}
      </span>
    </button>
  );
};

export default DetailPostReportButton;
